import { TRootState } from '@/store/store';

export const getReferralCode = ({ enterReferral }: TRootState) => enterReferral.referralCode;
export const isActivated = ({ enterReferral }: TRootState) => enterReferral.isActivated === true;
export const isActivatedFetching = ({ enterReferral }: TRootState) => enterReferral.isActivated === null;
